module.exports = __webpack_public_path__ + "static/media/9-10.0dff5a33.mp3";